document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.honeys-slider');
  const next = document.querySelector('.honeys-next');
  const prev = document.querySelector('.honeys-prev');
  if (!slider) return;

  const scrollAmount = 300;
  next?.addEventListener('click', () => slider.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  prev?.addEventListener('click', () => slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));

  // Reproduz/pausa vídeos quando visíveis
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('video');
      if (!video) return;
      if (entry.isIntersecting) video.play();
      else video.pause();
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.honeys-slide').forEach(slide => observer.observe(slide));
});
